export const PEG_BOARD_ADD    = 1;
export const PEG_BOARD_EDIT   = 2;
export const PEG_BOARD_UPDATE = 3;

